/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * 
 * @export
 * @interface ChatConversationWithMessages
 */
export interface ChatConversationWithMessages {
    /**
     * 
     * @type {number}
     * @memberof ChatConversationWithMessages
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof ChatConversationWithMessages
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ChatConversationWithMessages
     */
    claimId?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatConversationWithMessages
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationWithMessages
     */
    title?: string;
    /**
     * 
     * @type {Date}
     * @memberof ChatConversationWithMessages
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChatConversationWithMessages
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof ChatConversationWithMessages
     */
    messages?: Array<ChatMessage>;
}

/**
 * Check if a given object implements the ChatConversationWithMessages interface.
 */
export function instanceOfChatConversationWithMessages(value: object): value is ChatConversationWithMessages {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ChatConversationWithMessagesFromJSON(json: any): ChatConversationWithMessages {
    return ChatConversationWithMessagesFromJSONTyped(json, false);
}

export function ChatConversationWithMessagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatConversationWithMessages {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'userId': json['userId'],
        'title': json['title'] == null ? undefined : json['title'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'messages': json['messages'] == null ? undefined : ((json['messages'] as Array<any>).map(ChatMessageFromJSON)),
    };
}

export function ChatConversationWithMessagesToJSON(json: any): ChatConversationWithMessages {
    return ChatConversationWithMessagesToJSONTyped(json, false);
}

export function ChatConversationWithMessagesToJSONTyped(value?: Omit<ChatConversationWithMessages, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'claimId': value['claimId'],
        'userId': value['userId'],
        'title': value['title'],
        'messages': value['messages'] == null ? undefined : ((value['messages'] as Array<any>).map(ChatMessageToJSON)),
    };
}

